/**
 * @module websocket.event.handlers.airports.airport-added
 */
import { store } from '../../../../state/store'
import { setAirportListUpdated } from '../../../../state/websocket.slice'

export default function handleAirportAdded(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  console.log('#handleAirportAdded', {
    isSubscribed,
    channelId,
    data,
  })

  if (isSubscribed) {
    store.dispatch(setAirportListUpdated(data))
  }
} 